import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { getStatisticsSnapshot } from "../Actions/API/Statistics/StatisticsActions"
import { StatisticsState } from "../Reducers/API/Statistics/StatisticsReducer"
import { useAppState } from "./useReduxState"

export function useStatisticsSnapshot(appID?: string): StatisticsState {
    const dispatch = useDispatch()
    const statisticsState = useAppState(state => state.api.statistics)

    useEffect(() => {
        if (appID === undefined) {
            return
        }

        dispatch(getStatisticsSnapshot(appID))
    }, [appID, dispatch])

    return statisticsState
}
